import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/app';
import { UserTypeahead } from '@kineticdata/bundle-common';
import { I18n } from '@kineticdata/react';
import classNames from 'classnames';

const hasErrors = props => props.touched && props.errors.size > 0;

const connectUser = (Component, mapPropsToUsername) =>
  connect(
    (state, props) => {
      const usernameToConnect = mapPropsToUsername(props);
      return {
        usernameToConnect,
        user: usernameToConnect
          ? state.app.usersMap.get(usernameToConnect)
          : false,
      };
    },
    { fetchUsers: actions.fetchUsersRequest },
  )(Component);

const UserSelectionComponentSingle = connectUser(
  ({ selection, disabled, edit, remove, placeholder, user, fetchUsers }) => {
    // Fetch the user record
    useEffect(
      () => {
        if (typeof user === 'undefined' && selection) {
          fetchUsers({ usernames: [selection.get('username')] });
        }
      },
      [fetchUsers, user, selection],
    );
    return (
      <div className="input-group selection">
        <input
          className="form-control"
          type="text"
          disabled={disabled}
          value={
            selection
              ? `${
                  user
                    ? user.displayName || user.email
                    : user === false
                      ? 'User Not Found'
                      : 'Loading...'
                } (${selection.get('username')})`
              : ''
          }
          onFocus={() => edit(new MouseEvent('click'))}
          onChange={() => {}}
          placeholder={placeholder}
        />
        {selection &&
          !disabled && (
            <div className="input-group-append">
              <button
                className="btn btn-sm btn-clear"
                onClick={remove}
                type="button"
              >
                <span className="sr-only">Remove</span>
                <i className="fa fa-fw fa-times" />
              </button>
            </div>
          )}
      </div>
    );
  },
  props => (props.selection ? props.selection.get('username') : null),
);
const UserSelectionComponentMultiple = connectUser(
  ({ selection, disabled, remove, user, fetchUsers }) => {
    // Fetch the user record
    useEffect(
      () => {
        if (typeof user === 'undefined') {
          fetchUsers({ usernames: [selection.get('username')] });
        }
      },
      [fetchUsers, user, selection],
    );
    return (
      <div className="input-group selection">
        <input
          className="form-control"
          type="text"
          disabled
          value={`${
            user
              ? user.displayName || user.email
              : user === false
                ? 'User Not Found'
                : 'Loading...'
          } (${selection.get('username')})`}
        />
        {!disabled && (
          <div className="input-group-append">
            <button
              className="btn btn-sm btn-clear"
              onClick={remove}
              type="button"
            >
              <span className="sr-only">Remove</span>
              <i className="fa fa-fw fa-times" />
            </button>
          </div>
        )}
      </div>
    );
  },
  props => props.selection.get('username'),
);

const FieldWrapper = props => {
  const { EmptyOptionsPlaceholder } = props.renderAttributes
    ? props.renderAttributes.toObject()
    : {};

  return props.visible ? (
    <div className={classNames('form-group', props.className)}>
      {!props.omitLabel && (
        <label htmlFor={props.id} id={props.name}>
          <I18n>{props.label}</I18n>
          {props.required && <abbr title="required">*</abbr>}
        </label>
      )}

      {!props.enabled && props.renderAttributes.get('disabledMessage') ? (
        <p className="no-data">
          <I18n>{props.renderAttributes.get('disabledMessage')}</I18n>
        </p>
      ) : props.options &&
      props.options.isEmpty() &&
      EmptyOptionsPlaceholder ? (
        <EmptyOptionsPlaceholder />
      ) : (
        props.children
      )}
      {props.helpText && (
        <small>
          <I18n>{props.helpText}</I18n>
        </small>
      )}
      {hasErrors(props) && (
        <div>
          {props.errors.map(error => (
            <span className="help-block text-danger" key={error}>
              <I18n>{error}</I18n>
            </span>
          ))}
        </div>
      )}
    </div>
  ) : null;
};
export const UserField = props => (
  <FieldWrapper {...props}>
    <UserTypeahead
      id={props.id}
      value={props.value}
      allowNew={true}
      onChange={props.onChange}
      onBlur={props.onBlur}
      onFocus={props.onFocus}
      placeholder={props.placeholder}
      minSearchLength={1}
      components={{ Selection: UserSelectionComponentSingle }}
    />
  </FieldWrapper>
);

export const UserMultiField = props => (
  <FieldWrapper {...props}>
    <UserTypeahead
      multiple
      id={props.id}
      value={props.value}
      onChange={props.onChange}
      onBlur={props.onBlur}
      onFocus={props.onFocus}
      placeholder={props.placeholder}
      minSearchLength={1}
      components={{ Selection: UserSelectionComponentMultiple }}
    />
  </FieldWrapper>
);
